import { useData } from "./DataContext.js";

export default function ErrorsFormat (props)
{
    const gData = useData();

    const currentErrors = gData.state.errors;
    
    return (
	<span className="d-inline-flex align-items-center gap-1 user-select-none">
	    <span>Erreurs : </span>
	    <span>{currentErrors}</span>
	</span>
    );
}
